import { EventEmitter, Injectable, QueryList } from '@angular/core';
import { UserDataService } from './userData.service';
import { ApiService } from './communications/api.service';
import { AssetParticipants } from '../interfaces/AssetInfo';
import { SignalRService } from './communications/signalr.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { catchError, from, lastValueFrom, switchMap, throwError } from 'rxjs';
import { PublisherComponent } from '../components/publisher/publisher.component';
import * as constants from 'src/app/constants/constants';
import { StartAudioConnectorResponse } from '../interfaces/Responses/AudioConnectorResponse';
import { LoggerService } from './loggerService.service';

@Injectable({
  providedIn: 'root'
})

export class AudioConnectorService {

  translateSubtitlesOn = new BehaviorSubject<boolean>(false);
  translateSubtitleEnabled = new BehaviorSubject<boolean>(false);
  translationVoiceEnabled = new BehaviorSubject<boolean>(false);

  translateSubtitlesOn$ = this.translateSubtitlesOn.asObservable();
  translateSubtitleEnabled$ = this.translateSubtitleEnabled.asObservable();
  translationVoiceEnabled$ = this.translationVoiceEnabled.asObservable();


  constructor(private userDataService: UserDataService, private apiService: ApiService, private signalRService: SignalRService, private logger: LoggerService) {

  }

  start(participant: AssetParticipants) {
    var result = this.signalRService.startTranscription(this.userDataService.otSession!, this.userDataService.CallId!, this.userDataService.GetTranslatedStreamId(participant.connectionId).streamId,
      participant.connectionId, this.userDataService.assetInfo.transcriptionsLanguage!);

    result.then(res => {
      if (this.userDataService.assetInfo.participants.some(p => p.translateVoiceOn)) this.translateSubtitleEnabled.next(true);
      console.log("START audioConnectorId", result);
    });
  }

  startTranslation(participant: AssetParticipants) {
    var result = this.signalRService.startTranslation(this.userDataService.otSession!, this.userDataService.CallId!, participant.translationLanguage,
      this.userDataService.GetTranslatedStreamId(participant.connectionId).streamId, participant.connectionId, participant.originLanguage);

    result.then(res => {
      if (this.userDataService.assetInfo.participants.some(p => p.translateVoiceOn)) this.translateSubtitleEnabled.next(true);
      console.log("START audioConnectorId", result);
    });
  }

  stop(participant: AssetParticipants) {

    this.apiService.stopAudioConnector(this.userDataService.otSession!, participant.audioConnectorId!, participant.connectionId).subscribe({
      next: event => {
        participant.audioConnectorId = "";
        console.log("stop", event, this.userDataService.assetInfo?.participants);

        if (this.userDataService.assetInfo?.participants.some(p => p.audioConnectorId != undefined && p.audioConnectorId != '')) {
          console.log("no stop subtitles");
          return;
        }

        if (!participant.microphone) this.translationVoiceEnabled.next(false);

        this.translateSubtitleEnabled.next(false);
        console.log("stop subtitles", this.translateSubtitleEnabled.value);

        if (this.translateSubtitlesOn.value) this.translateSubtitles();
      },
      error: error => {
        console.log("Error on  : stopTranslation => " + error);
        this.logger.error("Error on  : stopTranslation => " + error);
      },
      complete: () => {
        console.log("Audio connector sttoped successfully");
      }
    });

  }

  stopTranslations(participant: AssetParticipants) {
    var result = this.signalRService.stopTranslations(this.userDataService.otSession!, this.userDataService.CallId!, this.userDataService.GetTranslatedStreamId(participant.connectionId).streamId, participant.connectionId);
    result.then(res => {
      if (!this.userDataService.assetInfo.transcriptionsOn) participant.audioConnectorId = "";

      participant.translateVoiceOn = false;

      console.log("stop", res, this.userDataService.assetInfo?.participants);

      if (this.userDataService.assetInfo?.participants.some(p => p.audioConnectorId != undefined && p.audioConnectorId != '')) {
        console.log("no stop subtitles");
        return;
      }

      if (!participant.microphone) this.translationVoiceEnabled.next(false);

      this.translateSubtitleEnabled.next(false);
      console.log("stop subtitles", this.translateSubtitleEnabled.value);

      if (this.translateSubtitlesOn.value) this.translateSubtitles();

    })
      .catch(error => {
        console.log("Error on  : stopTranslation => " + error);
      });
  }

  translateSubtitles() {
    this.translateSubtitlesOn.next(!this.translateSubtitlesOn.value);
    this.userDataService.assetInfo!.participants.forEach(participant => participant.translateSubtitleOn = this.translateSubtitlesOn.value);
    this.signalRService.setTranslateSubtitles(this.userDataService.assetInfo.id!, this.userDataService.CallId!, this.translateSubtitlesOn.value);
    console.log('translation subtitles on');
  }

  setTranslateSubtitlesOn(value: boolean) {
    this.translateSubtitlesOn.next(value);
  }

  setTranslationVoiceEnabled(value: boolean) {
    this.translationVoiceEnabled.next(value && this.userDataService.assetInfo.translationEnabled);
  }

  startAudioTranslate(publishers: QueryList<PublisherComponent>, data: StartAudioConnectorResponse) {
    console.log(data.userId, this.userDataService.Id, data.userConnectionId);

    var participant = this.userDataService.assetInfo?.participants.find(p => p.connectionId == data.userConnectionId);
    if (participant != undefined) {
      console.log("startAudioTranslate - set audioConnectId - translateActive", participant.name, data.translateActive);
      participant.audioConnectorId = data.audioConnectorId;
      participant.translateVoiceOn = data.translateActive;
    }
    else console.log("startAudioTranslate. UserName not found. Not audioconnectorId set!", data.userId);

    if (data.userId != this.userDataService.Id) return;
    if (!participant?.translateVoiceOn || participant.translateVoiceOn == undefined) return;

    console.log("startAudioTranslate", data.userId, participant?.translateVoiceOn);

    const targetPublisher = publishers.find(publisher => publisher.publisherType == constants.PublisherType.AudioTranslate);
    targetPublisher?.createAudioTranslatePublisher(data);
    targetPublisher?.publisher?.on("streamCreated", event => {
      console.log("STREAM CREATED PUBLIHSER AUDIO CONNECTOR", event.stream.name);
    });

    targetPublisher?.publisher?.on("streamDestroyed", event => {
      console.log("STREAM DESTROYED PUBLIHSER AUDIO CONNECTOR", event.stream.name);
    });
  }

  stopAudioTranslate(publishers: QueryList<PublisherComponent>, session: OT.Session) {
    console.log("stop audio connector from call component");
    const targetPublisher = publishers.find(publisher => publisher.publisherType == constants.PublisherType.AudioTranslate);
    if (targetPublisher?.publisher == null) {
      console.log("publisher null");
      return;
    }
    console.log("stop publisher", targetPublisher?.publish.name, publishers.length);

    try {
      session.unpublish(targetPublisher.publisher);
    } catch (ex) {
      console.log('ERROR: No estaba publicado', ex);
    }

    targetPublisher?.publisher.destroy();
    targetPublisher.publisher = null;
  }

  publishTranslatedAudio(publishers: QueryList<PublisherComponent>, filePath: string) {
    const audioContext = new (window.AudioContext)(); // || window.webkitAudioContext)();

    const targetPublisher = publishers.find(publisher => publisher.publisherType == constants.PublisherType.AudioTranslate);
    if (targetPublisher?.publisher == null || targetPublisher.publisher.getAudioSource() == null) {
      console.log("publisher null");
      return;
    }

    console.log(filePath);

    this.getAudioBuffer(filePath, audioContext).then(async myArrayBuffer => {
      if (myArrayBuffer == null) {
        console.log("BUFFER NULL");
        return;
      }
      const source = audioContext.createBufferSource();
      source.buffer = myArrayBuffer; // set the buffer in the AudioBufferSourceNode

      const destination = audioContext.createMediaStreamDestination();

      source.connect(destination); // connect the AudioBufferSourceNode to the destination so we can hear the sound
      source.start(); // start the source playing

      //cambia audio, solo se oye el mp3

      //targetPublisher?.publisher.setAudioSource(destination.stream.getAudioTracks()[0]);

      const tracks = destination.stream.getAudioTracks();
      if (tracks.length > 0 && tracks[0].readyState === 'live') {
        try {
          console.log("set new audio source");
          await targetPublisher?.publisher?.setAudioSource(tracks[0]);
        } catch (e) {
          console.log('Error al cambiar la fuente de audio:', e);
        }
      } else {
        console.log('La pista de audio no está disponible o no está activa.');
      }


    }).catch(error => {
      console.log('Error getAudioBuffer:', error);
    });
  }

  getAudioBuffer(url: string, audioContext: AudioContext): Promise<AudioBuffer> {
    return lastValueFrom(this.apiService.getAudioFile(url)
      .pipe(
        switchMap(audioData => from(audioContext.decodeAudioData(audioData))),
        catchError(error => {
          console.log('Error fetching or decoding audio data:', error);
          return throwError(error);
        })
      ));
  }

}


